import { render, staticRenderFns } from "./btnSearch.vue?vue&type=template&id=70ce4b2b&scoped=true&"
import script from "./btnSearch.vue?vue&type=script&lang=js&"
export * from "./btnSearch.vue?vue&type=script&lang=js&"
import style0 from "./btnSearch.vue?vue&type=style&index=0&id=70ce4b2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce4b2b",
  null
  
)

export default component.exports